import React from 'react';
import { FormattedHTMLMessage, useIntl } from 'react-intl';
import { Material, ProductInputDataRequiredFields } from '../../redux/product/productTypes';
import TextField from '../Textfield';
import InfoIcon from '@material-ui/icons/Info';
import { Tooltip, Grid, Divider } from '@material-ui/core';
import isFieldEmpty from '../../service/IsFieldEmpty';
import { ComboBox } from '@ktr/ktr-materialui-react';


interface Props {
    inputChanged(event: any): any
    yieldStrengthShaft?: number | null,
    shaftMaterial?: string
    shaftDiameter_d?: number | null,
    shaftInnerDiameter_diw?: number | null,
    errorFields?: ProductInputDataRequiredFields,
    materials: Array<Material>,

}

export default function Shaft(props: Props) {
    const { formatHTMLMessage: f } = useIntl();


    return (
        //<Panel title={f({id: 'app.shaft', defaultMessage: 'Shaft'})} className={classes.basicDataPanel}>
        <Grid xs={12} item style={{ marginTop: "20px" }}>
            <b>{f({ id: 'app.shaft', defaultMessage: 'Shaft' })}</b>
            <Divider></Divider>

            <form autoComplete="off">

                <Grid container>
                    <Grid item xs={12} md={7} style={{ paddingTop: "18px", marginLeft: "5px" }}>
                        {f({ id: 'app.shaft.material', defaultMessage: 'Material' })}
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ boxSizing: "unset" }}>
                        <ComboBox
                            //value={props.shaftDiameter_d === null ? "" : Object.assign({}, props.clampexSizes[props.clampexSizes.findIndex(value => value.shaftDiameter_d === props.shaftDiameter_d)])}
                            freeSolo={true}
                            value={props.shaftMaterial === null ? "" : props.shaftMaterial}
                            getOptionLabel={(value: Material) => String(value.name)}
                            errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                            //error={props.errorFields === undefined || (props.errorFields.shaftDiameter_d === true && props.shaftDiameter_d !== null) ? false : props.errorFields.shaftDiameter_d}
                            error={props.errorFields !== undefined && props.errorFields.shaftDiameter_d && isFieldEmpty(props.shaftMaterial)}
                            options={props.materials}
                            //onInputChange={(event, value: Material) => console.log(value)}
                            onChange={(event, value: Material) => props.inputChanged({
                              shaftMaterial: value.name === "" && value !== undefined ? undefined : value.name,
                                yieldStrengthShaft: value.yieldstrength === undefined ? undefined : value.yieldstrength
                            })}
                            onInputChange={(e,v) => props.inputChanged({ shaftMaterial: e.target.value === "" ? undefined : e.target.value })} 
                           

                            
                        />
                    </Grid>
                    <Grid item sm={2}>
                    </Grid>
                </Grid>






                <TextField
                    //error={props.errorFields === undefined || (props.errorFields.yieldStrengthShaft === true && props.yieldStrengthShaft !== null) ? false : props.errorFields.yieldStrengthShaft} 
                    error={props.errorFields !== undefined && props.errorFields.yieldStrengthShaft && isFieldEmpty(props.yieldStrengthShaft)}
                    type="number"
                    errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                    value={props.yieldStrengthShaft === null ? "" : props.yieldStrengthShaft}
                    onChange={e => props.inputChanged({ yieldStrengthShaft: e.target.value === "" ? null : Number(e.target.value) })}
                    labelBefore={<FormattedHTMLMessage id="app.shaft.yieldstrength" defaultMessage="Yieldstrength"></FormattedHTMLMessage>}
                    labelAfter={
                        <Grid container>
                            <Grid item>
                                N/mm²
                        </Grid>
                            <Grid item>
                                {props.shaftMaterial === "" || props.shaftMaterial === undefined ? "" :
                                    <Tooltip style={{ marginLeft: "10px" }} title={f({ id: 'app.yieldstrength.info', defaultMessage: 'Attention' }) || ""} arrow>
                                        <InfoIcon />
                                    </Tooltip>
                                }
                            </Grid>
                        </Grid> 

                    } />


                <TextField
                    //error={props.errorFields === undefined || (props.errorFields.shaftInnerDiameter_diw === true && props.shaftInnerDiameter_diw !== null) ? false : props.errorFields.shaftInnerDiameter_diw} 
                    error={props.errorFields !== undefined && props.errorFields.shaftInnerDiameter_diw && isFieldEmpty(props.shaftInnerDiameter_diw)}
                    type="number"
                    errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                    value={props.shaftInnerDiameter_diw === null ? "" : props.shaftInnerDiameter_diw}
                    onChange={e => props.inputChanged({ shaftInnerDiameter_diw: e.target.value === "" ? null : Number(e.target.value) })}
                    labelBefore={<FormattedHTMLMessage id="app.shaft.diameterdiw" defaultMessage="Shaftinnerdiameter diw"></FormattedHTMLMessage>}
                    labelAfter="mm" />
            </form>

        </Grid>


    )
}
